module.exports = __webpack_public_path__ + "img/dianxin1-2.f4a35372.jpg";